module.exports = class Currency
  constructor: (obj) ->
    _.merge(@, obj)
    @precision = if @rate_to_usd > 10 then 2 else 0
    if @code == HM.store.getters.default_currency && @symbol_native
      @symbol = @symbol_native
  prefix: -> if @format == 'do'    then @symbol else ''
  suffix: -> if @format == 'posle' then @symbol else ''

  localizedName: ->
    name = @code.toUpperCase() + ' - '
    name += if HM.is_russian then @name_ru else @name
    name

  @get: (code, currencies = Currency.all) ->
    if code == 'percent'
      new Currency({ format: 'posle', symbol: '%', code: 'percent' })
    else
      _.find(currencies, { code: code })

  @convert: (number, from, to) ->
    number * Currency.get(from).rate_to_usd / Currency.get(to).rate_to_usd

  @format: (options) ->
    value = options.value
    currency = options.currency || HM.store.getters.default_currency
    currency_item = Currency.get currency
    sign = options.sign || 'default' # default: "–" when needed, force: +/– always, none: never, transfer: '=>'
    sign = 'none' if sign == 'mobile' && HM.is_mobile
    color = options.color || false # true: green and red, neutral: red only, false: none
    precision = options.precision || currency_item.precision || 0
    roundType = options.roundType || 'round'

    return '' if not isFinite(value)
    return '' if not currency

    if precision == 0
      value = Math.round(value) if roundType == 'round'
      value = Math.floor(value) if roundType == 'floor'
    else
      value = Math.round(value + "e+2")  + "e-2"

    str = String(Math.abs value)
    if precision == 0 # Don't add spaces for non-rounded values
      for i in [0..Math.floor((str.length - (1 + i)) / 3)]
        str = str.substring(0, str.length - (4 * i + 3)) + ' ' + str.substring(str.length - (4 * i + 3))
    str = str.trim()
    str = str.split(' ').join(',') if HM.is_english


    suffix = currency_item.suffix()
    suffix = suffix.trim() if HM.is_mobile
    str = currency_item.prefix() + str + suffix

    if value > 0
      str = '+' + str if sign == 'force'
    if value < 0
      str = '–' + str if sign != 'none'
    if sign == 'transfer'
      str = '=>' + str

    switch color
      when 'neutral'
        # выделяем цветов (красным) только отрицательные числа, остальные — по умолчанию
        str = "<span style='color:#BA2525'>#{str}</span>" if value < 0
      when true
         # выделяем цветом все числа, и отрицательные, и положительные
        color_class = if value > 0 then '#3f9142' else '#BA2525'
        color_class = '' if value == 0
        str = "<span style='color:#{color_class}'>#{str}</span>"

    return str
  @parse: (stringValue) ->
    stringValue = stringValue.trim()
    result = stringValue.replace(/[^0-9|-]/g, '')
    if /[,\.]\d{2}$/.test(stringValue)
      result = result.replace(/(\d{2})$/, '.$1')
    return parseFloat(result)

  @calculateString: (str) ->
    return 0 unless /\d/.test(str)  # если в строке нет чисел.

    str = str.replace( /(\#\S*)/g, '.' ) # удаление всех тэгов
    str = str.replace( /\([\s\S]*?\)/g, '' ) # Игнорирование того, что внутри скобок.
    str = str.replace( /,/g, '.' ) # замена всех запятых на точки.

    sum = (sum, x) ->
      # Если есть умножение, то превращаем "2*2" в 4.
      x = if x.includes('*') then eval(x) else Number(x)
      sum + ( x || 0 )

    # From: "asdfasd 8 asdfadf 2*2 asdfasdf 01000 3.2 -400"
    # To:   ["8", "2*2", "01000", "3.2", "-400"]
    # Sum:  615.2
    try
      # в этой что-то не так
      # res = str.match( /\b(-?\d{0,}[\.*]?\d{1,})(?![^\(]*\))\b/g ).reduce sum, 0
      res = str.match( /-?[\d.*]+/g ).reduce sum, 0
    catch e
      res = 0
    return res

  @default_currencies: ->
    [
      new Currency({ code: 'rub', name: "Russian Ruble", name_ru: "Рубль (Россия)"}),
      new Currency({ code: 'byr', name: "Belarusian Ruble (old)", name_ru: "Рубль (Беларусь, старый)"}),
      new Currency({ code: 'byn', name: "Belarusian Ruble", name_ru: "Рубль (Беларусь, новый)"}),
      new Currency({ code: 'uah', name: "Ukrainian Hryvnia", name_ru: "Гривна (Украина)"}),
      new Currency({ code: 'eur', name: "Euro", name_ru: "Евро"}),
      new Currency({ code: 'usd', name: "US Dollar", name_ru: "Доллар (США)"}),
      new Currency({ code: 'cad', name: "Canadian Dollar", name_ru: "Доллар (Канада)"}),
      new Currency({ code: 'aud', name: "Australian Dollar", name_ru: "Доллар (Австралия)"}),
      new Currency({ code: 'nzd', name: "New Zealand Dollar", name_ru: "Доллар (Новая Зеландия)"}),
      new Currency({ code: 'vnd', name: "Vietnamese Dong", name_ru: "Донг (Вьетнам)"}),
      new Currency({ code: 'thb', name: "Thai Baht", name_ru: "Бат (Тайланд)"}),
      new Currency({ code: 'krw', name: "South Korean Won", name_ru: "Вона (Южная Корея)"}),
      new Currency({ code: 'amd', name: "Armenian Dram", name_ru: "Драм (Армения)"}),
      new Currency({ code: 'pln', name: "Polish Zloty", name_ru: "Злотый (Польша)"}),
      new Currency({ code: 'jpy', name: "Japanese Yen", name_ru: "Иена (Япония)"}),
      new Currency({ code: 'dkk', name: "Danish Krone", name_ru: "Крона (Дания)"}),
      new Currency({ code: 'nok', name: "Norwegian Krone", name_ru: "Крона (Норвегия)"}),
      new Currency({ code: 'czk', name: "Czech Republic Koruna", name_ru: "Крона (Чехия)"}),
      new Currency({ code: 'sek', name: "Swedish Krona", name_ru: "Крона (Швеция)"}),
      new Currency({ code: 'hrk', name: "Croatian Kuna", name_ru: "Куна (Хорватия)"}),
      new Currency({ code: 'gel', name: "Georgian Lari", name_ru: "Лари (Грузия)"}),
      new Currency({ code: 'lvl', name: "Latvian Lats", name_ru: "Лат (Латвия)"}),
      new Currency({ code: 'bgn', name: "Bulgarian Lev", name_ru: "Лев (Болгария)"}),
      new Currency({ code: 'mdl', name: "Moldovan Leu", name_ru: "Лей (Молдавия)"}),
      new Currency({ code: 'ron', name: "Romanian Leu", name_ru: "Лей (Румыния)"}),
      new Currency({ code: 'ltl', name: "Lithuanian Litas", name_ru: "Лит (Литва)"}),
      new Currency({ code: 'try', name: "Turkish Lira", name_ru: "Лира (Турция)"}),
      new Currency({ code: 'azn', name: "Azerbaijani Manat", name_ru: "Манат (Азербайджан)"}),
      new Currency({ code: 'omr', name: "Omani Rial", name_ru: "Оманский риал (Оман)"}),
      new Currency({ code: 'uyu', name: "Uruguayan Peso", name_ru: "Песо (Уругвай)"}),
      new Currency({ code: 'brl', name: "Brazilian Real", name_ru: "Реал (Бразилия)"}),
      new Currency({ code: 'myr', name: "Malaysian Ringgit", name_ru: "Ринггит (Малайзия)"}),
      new Currency({ code: 'prb', name: "Transnistrian Ruble", name_ru: "Рубль (Приднестровская Молдавская Республика)"}),
      new Currency({ code: 'inr', name: "Indian Rupee", name_ru: "Рупия (Индия)"}),
      new Currency({ code: 'idr', name: "Indonesian Rupiah", name_ru: "Рупия (Индонезия)"}),
      new Currency({ code: 'kgs', name: "Kyrgyzstan Som", name_ru: "Сом (Киргизия)"}),
      new Currency({ code: 'uzs', name: "Uzbekistan Som", name_ru: "Сум (Узбекистан)"}),
      new Currency({ code: 'kzt', name: "Kazakhstani Tenge", name_ru: "Тенге (Казахстан)"}),
      new Currency({ code: 'chf', name: "Swiss Franc", name_ru: "Франк (Швейцария)"}),
      new Currency({ code: 'gbp', name: "British Pound Sterling", name_ru: "Фунт стерлингов (Великобритания)"}),
      new Currency({ code: 'egp', name: "Egyptian Pound", name_ru: "Фунт (Египет)"}),
      new Currency({ code: 'ils', name: "Israeli New Sheqel", name_ru: "Шекель (Израиль)"}),
      new Currency({ code: 'cny', name: "Chinese Yuan", name_ru: "Юань (Китай)"}),
      new Currency({ code: 'btc', name: "Bitcoin", name_ru: "Биткоин"}),
      new Currency({ code: 'mbtc', name: "MilliBitcoin", name_ru: "МиллиБиткоин (1/1000 BTC)"})
    ]
